import React from 'react';
import Home from "./pages/home"
import './styles/app.scss';

function App() {
  return (
    <Home />
  );
}

export default App;
